var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "Add"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "area",
    width: 24.76239,
    height: 25.25019,
    fill: "none",
    y: -0.07006,
    x: 0.06169
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "doc",
    fill: "currentColor",
    d: "m12.50928,24.81078a12.16676,12.30745 0 0 1 -8.66126,-3.62863a12.16676,12.30745 0 0 1 -3.58715,-8.76142a12.16676,12.30745 0 0 1 3.58797,-8.76059a12.16676,12.30745 0 0 1 8.66045,-3.62946a12.16676,12.30745 0 0 1 8.66126,3.62946a12.16676,12.30745 0 0 1 3.58715,8.76059a12.16676,12.30745 0 0 1 -3.58797,8.76059a12.16676,12.30745 0 0 1 -8.66045,3.62946zm-4.89937,-13.21605a0.81656,0.826 0 0 0 -0.81656,0.826a0.81656,0.826 0 0 0 0.81656,0.826l4.08281,0l0,4.13002a0.81656,0.826 0 0 0 0.81656,0.826a0.81656,0.826 0 0 0 0.81656,-0.826l0,-4.13002l4.08281,0a0.81656,0.826 0 0 0 0.81656,-0.826a0.81656,0.826 0 0 0 -0.81656,-0.826l-4.08281,0l0,-4.13002a0.81656,0.826 0 0 0 -0.81656,-0.826a0.81656,0.826 0 0 0 -0.81656,0.826l0,4.13002l-4.08281,0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add_icon.e421c878bb4b9ad5ba487dca15ccd35a.svg";
export { ForwardRef as ReactComponent };